<section *ngIf="response">
    <div class="meeting-step-header">
      <h4>First Meeting Form</h4>
    </div>
    <survey-project-meeting *ngIf="auth.isProject() || auth.isAdmin() || auth.isProjectBoard() || auth.isCallManager()" [step]="1"></survey-project-meeting>
</section>

<section *ngIf="response2">
    <div class="meeting-step-header">
      <h4>Second Meeting Form</h4>
    </div>
    <survey-project-meeting *ngIf="auth.isProject() || auth.isAdmin() || auth.isProjectBoard() || auth.isCallManager()" [step]="2"></survey-project-meeting>
</section>

<section *ngIf="response3">
    <div class="meeting-step-header">
      <h4>Third Meeting Form</h4>
    </div>
    <survey-project-meeting *ngIf="auth.isProject() || auth.isAdmin() || auth.isProjectBoard() || auth.isCallManager()" [step]="3"></survey-project-meeting>
</section>

<section *ngIf="response4">
    <div class="meeting-step-header">
      <h4>Advice Form</h4>
    </div>
    <survey-project-advice *ngIf="auth.isProject() || auth.isAdmin() || auth.isCallManager() || auth.isProjectBoard()"></survey-project-advice>
</section>

<section>
    <div class="meeting-step-header">
      <h4>Final Survey</h4>
    </div>
    <form-summary [data]="dataEpe" [report]="false"></form-summary>
    <form-summary [data]="dataProject" [report]="false"></form-summary>
</section>
